import React from 'react';
import { useKeycloak } from '../services/KeycloakProvider';
import { Navigate } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import './Index.css';
import { HomePageCard } from './pages/HomePageCard';

export const Index = () => {
  const keycloak = useKeycloak();
  if (keycloak.authenticated) {
    return <Navigate to={'/home'} />;
  }

  return (
    <div className='index' >
      <h1 className="index-logo-container" id='page-heading' role='heading' aria-level={1} tabIndex={-1}>
        <div className="index-logo">
          <a href="https://b2ai-voice.org">
            <img fetchPriority="high" decoding="async" src="assets/images/logo.svg" alt="B2Ai Voice Logo" />
          </a>
          <div className="index-logo-text">
            <Typography fontWeight={100}>Voice As a Biomarker of Health</Typography>
          </div>
        </div>
      </h1>

      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
          <HomePageCard
            title="Register"
            description="Create an account to participate in the B2Ai Voice Study."
            image="/assets/images/b2ai-register.jpg"
            imageAlt="Register as a new participant"
            buttonText="Register"
            route="/register"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <HomePageCard
            title="Sign in"
            description="Sign in with your account to B2Ai Voice."
            image="/assets/images/b2ai-signin.jpg"
            imageAlt="Sign in with your account to B2Ai Voice"
            buttonText="Sign in"
            route="/signin"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <HomePageCard
            title="Learn more"
            description="Learn more about the B2Ai Voice Study."
            image="/assets/images/b2ai-learn-more.jpg"
            imageAlt="Go to b2ai-voice.org"
            buttonText="Go to b2ai-voice.org"
            route="https://b2ai-voice.org/"
          />
        </Grid>
      </Grid>
    </div>
  );
};

